module.exports = {
  metric: {
    'tons/CO2e': {
      name: {
        singular: 'Metric ton of CO2 equivalent',
        plural: 'Metric tons of CO2 equivalent'
      }
      , to_anchor: 1
    },
    'kg/CO2e': {
      name: {
        singular: 'Kilogram of CO2 equivalent',
        plural: 'Kilograms of CO2 equivalent'
      }
      , to_anchor: 1000
    }
  },
  imperial: {},
  _anchors: {
    metric: {
      unit: 'tons/CO2e'
      , ratio: .000001
    }
  }
};
